<section class="learning-science-section">
  <div class="content-container">
    <div class="text-content">
      <div class="text-wrapper">
        <h2 class="section-title">{{ title }}</h2>
        <h3 class="section-subtitle">{{ subtitle }}</h3>
        <a [href]="ctaLink" class="cta-button" role="button">
          {{ ctaText }}
        </a>
      </div>
    </div>
    <div class="image-content">
      <div class="image-wrapper">
        <img
          src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80"
          alt="Students collaborating and learning with technology"
          class="content-image"
        />
        <div class="image-overlay">
          <div class="overlay-content">
            <div class="research-stats">
              <div class="stat-item">
                <div class="stat-number">89%</div>
                <div class="stat-label">Student Engagement</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">92%</div>
                <div class="stat-label">Learning Outcomes</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">95%</div>
                <div class="stat-label">Instructor Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
